import type { SVGProps } from "react";
import { icons } from "./icon-data.js";

export type IconName =
  | "arrowDown"
  | "arrowLeft"
  | "arrowRight"
  | "arrowUp"
  | "arrowUpRight"
  | "bell"
  | "bellFill"
  | "bellPlus"
  | "book"
  | "bookFill"
  | "bookmark"
  | "bookmarkFill"
  | "bubble"
  | "bubbleFill"
  | "bubblePlus"
  | "bubblePlusFill"
  | "businessBag"
  | "businessBagFill"
  | "camera"
  | "cameraFill"
  | "caretDown"
  | "caretUp"
  | "check"
  | "chevronDoubleLeft"
  | "chevronDoubleRight"
  | "chevronDown"
  | "chevronLeft"
  | "chevronRight"
  | "chevronUp"
  | "circle"
  | "circleCheck"
  | "circleCheckFill"
  | "circleClose"
  | "circleCloseFill"
  | "circleExclamation"
  | "circleExclamationFill"
  | "circleFill"
  | "circleInfo"
  | "circleInfoFill"
  | "circlePlus"
  | "circlePlusFill"
  | "circleQuestion"
  | "circleQuestionFill"
  | "circleUpRight"
  | "circleUpRightFill"
  | "clock"
  | "clockFill"
  | "close"
  | "coffee"
  | "coffeeFill"
  | "coins"
  | "coinsFill"
  | "company"
  | "companyCheck"
  | "companyCheckFill"
  | "companyFill"
  | "compass"
  | "compassFill"
  | "crown"
  | "crownFill"
  | "desktop"
  | "desktopFill"
  | "diamond"
  | "diamondFill"
  | "document"
  | "documentFill"
  | "documentText"
  | "documentTextFill"
  | "eye"
  | "eyeFill"
  | "eyeSlash"
  | "eyeSlashFill"
  | "faceSmile"
  | "faceSmileFill"
  | "filter"
  | "filterFill"
  | "fire"
  | "fireFill"
  | "flag"
  | "flagFill"
  | "folder"
  | "folderFill"
  | "globe"
  | "globeFill"
  | "graduation"
  | "graduationFill"
  | "heart"
  | "heartFill"
  | "home"
  | "homeFill"
  | "like"
  | "likeFill"
  | "lineHorizontal"
  | "location"
  | "locationFill"
  | "lock"
  | "lockFill"
  | "lockOpen"
  | "lockOpenFill"
  | "megaphone"
  | "megaphoneFill"
  | "menu"
  | "message"
  | "messageFill"
  | "microphone"
  | "microphoneFill"
  | "minus"
  | "mobile"
  | "mobileFill"
  | "moreHorizontal"
  | "moreVertical"
  | "palette"
  | "paletteFill"
  | "pencil"
  | "pencilFill"
  | "person"
  | "personFill"
  | "personPlus"
  | "personPlusFill"
  | "persons"
  | "personsFill"
  | "phone"
  | "phoneFill"
  | "pin"
  | "pinFill"
  | "plus"
  | "search"
  | "send"
  | "sendFill"
  | "sparkle"
  | "sparkleFill"
  | "square"
  | "squareFill"
  | "star"
  | "starFill"
  | "tag"
  | "tagFill"
  | "template"
  | "templateFill"
  | "thunder"
  | "thunderFill"
  | "ticket"
  | "ticketFill"
  | "triangleExclamation"
  | "triangleExclamationFill"
  | "trophy"
  | "trophyFill"
  | "verifiedCheck"
  | "verifiedCheckFill"
  | "verifiedStar"
  | "verifiedStarFill";

export interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
  size?: number | string;
}

export function Icon({ name, size, ...rest }: IconProps) {
  const d = icons[name];
  if (!d) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox={d.viewBox}
      fill="none"
      // body strings are emitter-controlled <path> markup — geometry,
      // numeric fills and transforms only; no .fig-authored text reaches them.
      // biome-ignore lint/security/noDangerouslySetInnerHtml: icon glyph data is static, bundled with the design system, never user input.
      dangerouslySetInnerHTML={{ __html: d.body }}
      {...rest}
    />
  );
}
export default Icon;
